import React from 'react';
import { Container } from 'react-bootstrap';

const Payment = () => {
    return (
        <Container>
            <h2 className='text-info text-center mt-5'>Payment System Will Comming Soon...</h2>
        </Container>
    );
};

export default Payment;